export default "/_next/static/assets/images/sprite.5ec77086044a3b6ffb7fdbc97dbd9091.svg";